/**
 * 产品水印 / Logo：按 check_type 配置
 *
 * 新增产品：
 * 1. logo 文件放到 src/assets/
 * 2. 在 PRODUCT_LOGO_MAP 增加一行，如 '200': require('@/assets/xxx-logo.svg')
 */

export const PRODUCT_LOGO_MAP = {
  '36': require('@/assets/ithenticate-logo.svg'),
  '105': require('@/assets/turnitin-logo.svg')
}

export const DEFAULT_PRODUCT_LOGO = require('@/assets/turnitin-logo.svg')

export function getProductLogoSrc(checkType) {
  return PRODUCT_LOGO_MAP[String(checkType)] || DEFAULT_PRODUCT_LOGO
}
